import { render, staticRenderFns } from "./Add_process.vue?vue&type=template&id=29efb6cf&scoped=true&"
import script from "./Add_process.vue?vue&type=script&lang=js&"
export * from "./Add_process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29efb6cf",
  null
  
)

export default component.exports